import { sendLogEvent } from '../api/BridgeApi'

let sharedOptions: any = {}

function send(name: string, options?: object, ...rest: any) {
  console.log(process.env)
  const isLocal = process.env.NODE_ENV === 'development'
  const eventValue = {
    ...options,
    ...rest.reduce((acc: object, cur: any) => ({ ...acc, [cur]: sharedOptions[cur] }), {}),
  }

  save(options)

  if (isLocal) {
    console.log(`AF dispatch(name: ${name}), options: `, options, ' eventValue: ', eventValue) // eslint-disable-line no-console

    return
  }

  sendLogEvent({ name: name, values: eventValue })
}

function save(preserve: any) {
  sharedOptions = {
    ...sharedOptions,
    ...preserve,
  }
}

function clear() {
  sharedOptions = {}
}

export default {
  send,
  save,
  clear,
}
